import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { DsRouterLinkModule } from '@amfam/shared/ui/ds-router-link';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { BillingFaqComponent } from './components/billing-faq/billing-faq.component';
import { ClaimsFaqComponent } from './components/claims-faq/claims-faq.component';
import { FaqLinksComponent } from './components/faq-links/faq-links.component';
// components/directives/pipes
import { FaqComponent } from './components/faq-wrapper/faq.component';
import { GoPaperlessFaqComponent } from './components/go-paperless-faq/go-paperless-faq.component';
import { PolicyFaqComponent } from './components/policy-faq/policy-faq.component';
import { FaqRoutes } from './routing/faq.routes';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(FaqRoutes),
    UiKitModule,
    SharedServicesModule,
    DsRouterLinkModule,
    ReactiveFormsModule,
    PipesModule
  ],
  declarations: [
    FaqComponent,
    GoPaperlessFaqComponent,
    PolicyFaqComponent,
    ClaimsFaqComponent,
    BillingFaqComponent,
    FaqLinksComponent
  ],
  exports: [
    FaqComponent,
    GoPaperlessFaqComponent,
    PolicyFaqComponent,
    ClaimsFaqComponent,
    BillingFaqComponent,
    FaqLinksComponent
  ]
})
export class SharedFaqFeatureModule {}
